// extracted by mini-css-extract-plugin
module.exports = {"areaTypeDetails":"AreaTypeDetails_areaTypeDetails__2z_Zu","icon":"AreaTypeDetails_icon__11mrn"};